import moment from 'moment';

export const enrichMessageCollection = (messageResources) => {
  const startOfTime = moment('1970-01-01').format('l');
  const data = {
    currentDayMoment: startOfTime,
    currentSenderUserId: null,
    currentIsNew: null,
  };

  return messageResources.map((messageResource) => {
    const isNewSender = !!(messageResource.attr('senderUserId') !== data.currentSenderUserId);
    if (isNewSender) {
      data.currentSenderUserId = messageResource.attr('senderUserId');
    }

    const isFirstNew = messageResource.isTruthy('isNew') && !data.currentIsNew;
    data.currentIsNew = messageResource.isTruthy('isNew');

    const isNewDay = !!(moment(data.currentDayMoment).diff(messageResource.attr('publishedDate'), 'day'));
    if (isNewDay) {
      data.currentDayMoment = moment(messageResource.attr('publishedDate')).format('l');
    }

    return {
      messageResource,
      enrichedData: {
        isFirstNew,
        isNewDay,
        isNewSender,
      },
    };
  });
};
